import { Grid, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useState, useRef, useEffect } from "react";
import NORow from "../../../../library/custom/noRow/noRow";
import Loader, { TableLoader } from "../../../../library/common/Loader";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  HBNEXT_ORG_ID,
  ISwitch,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  SW3RD_PARTY_INSPECTOR,
  SW_CLIENT_MANAGER,
  USER_ID,
} from "../../../../constant/constant";
import {
  INSSTATUS,
  SW_REPORTS_COUNT,
} from "../../../../constant/storm-water/constant";
import {
  convertUTCtoLocalTimeZone,
  getFormatedDate,
  InactiveClient,
  setColumnVisibilityModel1,
  stripTimeToDate,
  columnVisibilityModel,
} from "../../../../utils/helper";
import FormControl from "@mui/material/FormControl";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import DialogBox from "../../../../library/common/DialogBox";
import {
  checkPrivileges,
  hasAllPrivileges,
} from "../../../../utils/rolesHelper";
import * as assetsAction from "../../../../redux/actions/assetsAction";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import commonImages from "../../../../assets";
import Buttons from "../../../../library/custom/button/Button";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import { toast } from "react-toastify";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import {
  SW_INSPECTION_LIST,
  SW_INSPECTION_VIEW,
  SW_INSPECTION_ADD,
  SW_INSPECTION_PROOF,
  SW_INSPECTION_PROOF_VIEW,
  SW_REPORT_HISTORY,
} from "../../../../constant/routeContant";

const ReportList = ({
  swInspectionList,
  isLoading,
  getSwInspectionListData,
  count,
  handleEditOnClick,
  viewOnClick,
  inspectionTypeValue,
  isSearchClientLoading,
  allClients,
  searchClient,
  handleDeleteOnClick,
  onRowClick,
  statusHander,
  statusId,
  stateData,
  stodayDate,
  scalculatedDate,
  setProjects,
  projects,
  setClients,
  clients,
  selectedReports,
  setSelectedReports,
  getBulkInspectionDetailsData,
  getBulkInspectionFiles,
  getBulkInspectionFilesData,
  getProjectContactsEmailDetailsData,
  handleAddOnClick,
  frequencyId,
  setFrequencyId,
  isProfile,
  getOpenItemDetailData,
  swOpenItemDetail,
  isFromDashboard,
  isUseridPass,
  setEmailReset,
  reportHistoryOnClick,
  search,
  setSearch,
  swInspectionListData,
  statusIdsvalue,
  sendEmailOnClick,
  viewProjectOnClick,
  myReportsToggle,
  onMyReportsToggle,
  state,
}) => {
  const CHECK_PRE =
    !hasAllPrivileges(SW_CLIENT_MANAGER) &&
    !hasAllPrivileges(SW3RD_PARTY_INSPECTOR);

  const CHECK_PRE_SHOW =
    hasAllPrivileges(SW_CLIENT_MANAGER) ||
    hasAllPrivileges(SW3RD_PARTY_INSPECTOR);

  const dispatch = useDispatch();

  const InspectionOpenItemCount = swOpenItemDetail?.data?.openItemList;

  let contentMessage;

  console.log("log");
  if (InspectionOpenItemCount === "" || InspectionOpenItemCount?.length === 0) {
    contentMessage = "Are you sure you want to delete this report?";
  } else if (InspectionOpenItemCount?.length !== 0) {
    contentMessage = `This report has ${InspectionOpenItemCount?.length} open item(s). Are you sure you want to delete this report?`;
  }

  const HBView =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12, 17]);
  const adminView = checkPrivileges([139]);
  const clientView = LOGIN_ORG_ID() !== ORG_ID();

  const savedSessionFilterObj = useRef(
    (() => {
      const shouldPreserve =
        sessionStorage.getItem("swReportListPreserveState") === "true";
      if (!shouldPreserve) return null;
      try {
        return JSON.parse(
          sessionStorage.getItem("swReportListFilterObj") || "null",
        );
      } catch {
        return null;
      }
    })(),
  ).current;

  const [pageSize, setPageSize] = useState(() => {
    if (savedSessionFilterObj) {
      return savedSessionFilterObj.pageSize || PAGE_SIZE;
    }
    return PAGE_SIZE;
  });

  const [page, setPage] = useState(() => {
    if (savedSessionFilterObj) {
      const restoredPage = savedSessionFilterObj.page ?? 1;
      return restoredPage > 0 ? restoredPage - 1 : 0;
    }
    return 0;
  });

  const [inspectionType, setInspectionType] = useState(() => {
    if (savedSessionFilterObj) {
      return savedSessionFilterObj.inspectionTypeId || undefined;
    }
    return undefined;
  });

  const [fromDate, setFromDate] = useState(() => {
    if (savedSessionFilterObj) {
      return savedSessionFilterObj.startDate || null;
    }
    return null;
  });

  const [toDate, setToDate] = useState(() => {
    if (savedSessionFilterObj) {
      return savedSessionFilterObj.endDate || null;
    }
    return null;
  });

  React.useEffect(() => {
    if (savedSessionFilterObj) {
      if (savedSessionFilterObj.projectObj) {
        setProjects(savedSessionFilterObj.projectObj);
      }
      if (savedSessionFilterObj.clientObj) {
        setClients(savedSessionFilterObj.clientObj);
      }
      if (savedSessionFilterObj.frequencyId) {
        setFrequencyId(savedSessionFilterObj.frequencyId);
      }
      if (savedSessionFilterObj.stateId) {
        setSelectedStateId(savedSessionFilterObj.stateId);
      }
    }
    sessionStorage.removeItem("swReportListPreserveState");
    sessionStorage.removeItem("swReportListStatusId");
    sessionStorage.removeItem("swReportListFilterObj");
  }, []);

  const [pageSizeDownloads, setPageSizeDownloads] = useState(() => {
    if (savedSessionFilterObj && savedSessionFilterObj.statusId === 8) {
      return savedSessionFilterObj.pageSizeDownloads || PAGE_SIZE;
    }
    return PAGE_SIZE;
  });
  const isFirstRender = useRef(true);
  const isFirstStatusRender = useRef(true);
  const hasRestoredFromSession = useRef(!!savedSessionFilterObj);
  const [selectedREportsError, setselectedREportsError] = useState(false);
  const [downloadsPage, setDownloadsPage] = useState(() => {
    if (savedSessionFilterObj && savedSessionFilterObj.statusId === 8) {
      const restoredPage = savedSessionFilterObj.downloadsPage ?? 0;
      return restoredPage >= 0 ? restoredPage : 0;
    }
    return 0;
  });
  const [statusIds, setStatusIds] = useState();
  const [selectedStateId, setSelectedStateId] = useState(() => {
    if (savedSessionFilterObj) {
      return savedSessionFilterObj.stateId || "";
    }
    return "";
  });

  const handleMyReportsToggle = (e) => {
    const isChecked = e.target.checked;
    onMyReportsToggle(isChecked);
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",
      page: 1,
      pageSize: pageSize,
      userId: isChecked ? parseInt(USER_ID()) : "",
      projectObj: projects,
      clientObj: clients,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
  };

  const [cusid, setcusid] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [projectSearchText, setProjectSearchText] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const debouncedProjectSearch = useDebounce(projectSearchText, 500);

  const deleteReport = (report) => {
    if (InactiveClient()) return;
    const customerId = report?.customerId;
    const reportId = report?.reportId;
    setcusid(customerId);
    setOpenModal(true);
    setSelectedRow(reportId);
    const data = {
      questionList: null,
      setupId: null,
      projectId: null,
      questionSetId: null,
      itemStatus: 2,
      orgId: null,
      inspectionId: [report?.reportId],
    };
    getOpenItemDetailData(data);
  };
  const deletehandle = () => {
    setOpenModal(false);
    const swinsreportdata = {
      selectedRow,
      cusid,
    };
    handleDeleteOnClick(swinsreportdata);
  };

  const allProject = useSelector((state) => state.getAssetDynomoList);
  const isProjectLoading = allProject?.isLoading;

  const [filter, setFilter] = useState({
    searchType: [],
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const autoComp = useRef(null);
  const autoCompPro = useRef(null);

  const [asssetName, setAsssetName] = useState(false);
  const [clientName, setClientName] = useState(false);

  const inspectionTypeOnChanges = (e) => {
    setFrequencyId("");
    setInspectionType(e.target.value);
  };
  const frequencyOnChanges = (e) => {
    setFrequencyId(e.target.value);
  };
  const stateOnChanges = (e) => {
    setSelectedStateId(e.target.value);
  };
  const onchangeToDatePicker = (e) => {
    setToDate(e);
  };
  const onchangeFromDatePicker = (e) => {
    setFromDate(e);
  };
  const onChangeProjects = (value) => {
    setProjects(value);
    setAsssetName(true);
    setPage(0);
    const data = {
      page: 1,
      search: search ? search : "",
      projectId: value?.key ? value?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",

      pageSize: pageSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: value,
      clientObj: swInspectionListData?.filterObj?.clientObj,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
  };

  const onChangeClients = (value) => {
    setClients(value);
    setClientName(true);
    setPage(0);

    const data = {
      page: 1,
      search: search ? search : "",
      projectId: 0,
      customerId: value?.key ? value?.key : parseInt(ORG_ID()),
      statusId: statusId,
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",

      pageSize: pageSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: swInspectionListData?.filterObj?.projectObj,
      clientObj: value,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
    setProjects();

    const ele = autoCompPro.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator",
    )[0];
    if (ele) {
      ele.click();
    }
  };

  function handleAllProjectSearch(event, value) {
    setProjectSearchText(event.target.value);
  }

  useEffect(() => {
    dispatch(
      assetsAction.getAssetDynomoList({
        orgId: clients?.key ? clients?.key : parseInt(ORG_ID()),
        searchText: debouncedProjectSearch,
        type: 5,
      }),
    );
  }, [debouncedProjectSearch]);

  const handlePagignation = (newPage) => {
    const safePage = newPage < 0 ? 0 : newPage;
    setPage(safePage);
    const data = {
      page: safePage + 1,
      search: search ? search : "",
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",
      pageSize: pageSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: projects,
      clientObj: clients,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
  };
  const handleDownloadsPagignation = (newPage) => {
    setDownloadsPage(newPage);
    const data = {
      page: newPage + 1,
      pageSize: pageSizeDownloads,
      userId: parseInt(USER_ID()),
    };
    getBulkInspectionFilesData(data);

    const filterData = {
      ...swInspectionListData?.filterObj,
      downloadsPage: newPage,
      pageSizeDownloads: pageSizeDownloads,
      statusId: statusId,
      statusIds: statusIdsvalue,
    };
    dispatch(swInspectionAction.getSwInspectionFilterObj(filterData));
  };

  const handleautoSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      search: search ? search : "",
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",
      page: 1,
      pageSize: newPazeSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: projects,
      clientObj: clients,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
  };
  const handlePageSizeDownloadsChange = (newPazeSize) => {
    setPageSizeDownloads(newPazeSize);
    setDownloadsPage(0);
    const data = {
      page: 1,
      pageSize: newPazeSize,
      userId: parseInt(USER_ID()),
    };
    getBulkInspectionFilesData(data);
    const filterData = {
      ...swInspectionListData?.filterObj,
      downloadsPage: 0,
      pageSizeDownloads: newPazeSize,
      statusId: statusId,
      statusIds: statusIdsvalue,
    };
    dispatch(swInspectionAction.getSwInspectionFilterObj(filterData));
  };

  const onChangeType = (item) => {
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      const searchType = prevStates.searchType;
      const filter =
        searchType && searchType.filter((its) => its?.key === item?.key);
      if (filter[0] === undefined) {
        prevStates.searchType = [item];
        setStatusIds(item?.key);
      } else {
        prevStates.searchType = [];
      }
      return prevStates;
    });
  };

  const handleApply = () => {
    const data = {
      search: search ? search : "",
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId: statusId,
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",
      page: 1,
      pageSize: pageSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: projects,
      clientObj: clients,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };
    getSwInspectionListData(data);
    handleClose();
  };

  const handleClear = () => {
    setProjects();
    setClients();
    setInspectionType("");
    setFrequencyId("");
    setStatusIds("");
    setSelectedStateId("");
    setFromDate(null);
    setToDate(null);
    setSearch("");
    setPage(0);
    setDownloadsPage(0);
    setPageSize(PAGE_SIZE);
    setPageSizeDownloads(PAGE_SIZE);
    setFilter((prevState) => {
      const prevStates = { ...prevState };
      prevStates.searchType = [];
      return prevStates;
    });
    const dataClear = {
      search: "",
      inspectionTypeId: 0,
      frequencyId: "",
      projectId: stateData ? stateData?.projectId : 0,
      customerId: parseInt(ORG_ID()),
      statusId: statusId,
      startDate: statusId === 7 ? getFormatedDate(stodayDate) : "",
      endDate: statusId === 7 ? getFormatedDate(scalculatedDate) : "",
      page: 1,
      pageSize: PAGE_SIZE,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: "",
    };
    getSwInspectionListData(dataClear);
    handleClose();
  };

  const columnVisibilityKey = `columnVisibilitySwReportList_${statusId}`;
  var retrievedColumnVisibility = JSON.parse(
    localStorage.getItem(columnVisibilityKey),
  );

  const columns = [
    {
      field: "reportId",
      headerName: "Report ID",
      flex: 1,
      hideable: false,
      filterable: false,
      minWidth: 60,
    },

    {
      field: "projectName",
      headerName: "Project",
      flex: 1,
      filterable: false,
      minWidth: 100,
    },
    {
      field: "customer",
      headerName: "Client",
      flex: 1,
      filterable: false,
      minWidth: 90,
    },

    {
      field: statusId === 6 ? "dateReported" : "dateScheduled",
      headerName: statusId === 6 ? "Date Submitted" : "Date Scheduled",
      flex: 1,
      filterable: false,
      minWidth: 100,
      renderCell: ({ row }) =>
        statusId === 6 ? (
          <div title={stripTimeToDate(row?.dateReported)}>
            {stripTimeToDate(row?.dateReported) || "N/A"}
          </div>
        ) : (
          <div title={row?.dateScheduled}>{row?.dateScheduled}</div>
        ),
    },
    {
      field: "dateOfEntry",
      headerName: "Inspection Date",
      flex: 1,
      filterable: false,
      minWidth: 90,
      renderCell: ({ row }) => (
        <div title={row?.dateOfEntry}>{row?.dateOfEntry ?? "N/A"}</div>
      ),
    },
    {
      field: "openItemCount",
      headerName: "Open Items",
      flex: 0.8,
      filterable: false,
      minWidth: 70,
      renderCell: ({ row }) => (
        <div title={row?.openItemCount}>{row?.openItemCount ?? "N/A"}</div>
      ),
    },
    {
      field: "inspectionBy",
      headerName: "Inspected By",
      flex: 1,
      filterable: false,
      minWidth: 90,
    },
    {
      field: "inspectionType",
      headerName: "Inspection Type",
      flex: 1,
      filterable: false,
      minWidth: 90,
    },
    {
      field: "stateName",
      headerName: "State",
      flex: 1,
      filterable: false,
      minWidth: 90,
    },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 1,
      filterable: false,
      minWidth: 90,
      renderCell: (rows) => (
        <div>
          {rows?.row?.frequency}{" "}
          {rows?.row?.frequencyId === 5 &&
          rows?.row?.isFluid &&
          rows?.row?.insTerm
            ? `(${rows?.row?.insTerm})`
            : ""}
          {rows?.row?.frequencyId === 7 ? (
            <span
              className="frequencyInDays"
              title={rows?.row?.frequencyInDays}
            >
              {"- " + rows?.row?.frequencyInDays}
            </span>
          ) : (
            ""
          )}
        </div>
      ),
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={count ?? 0}
          numberOfItemsPerPage={10}
          incidentLists={swInspectionList ?? []}
          fileNameXL={"inspections"}
        />
      ),
      width: 70,
      sortable: false,
      disableClickEventBubbling: true,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const currentDate = new Date();
        const scheduledDate = new Date(rows?.row?.dateScheduled);
        const isTodayOrUpcoming = scheduledDate <= currentDate;
        return statusId === 6 && !isProfile ? (
          <ReportRowManipulte
            rows={rows}
            edit={
              checkPrivileges([12, 102, 103]) &&
              !hasAllPrivileges(SW3RD_PARTY_INSPECTOR)
            }
            view={checkPrivileges([12, 102, 103, 104])}
            editOnClick={(row) => handleEditOnClick(row)}
            viewOnClick={(row) => viewOnClick(row)}
            editLabel="Edit Report"
            viewLabel={
              rows?.row?.isExternal ? "View Submission Proof" : "View Report"
            }
            deleted={checkPrivileges([12, 102])}
            deleteOnClick={(row) => deleteReport(row)}
            deleteLabel="Delete Report"
            sendEmail={checkPrivileges([12, 102, 103, 104])}
            sendEmailOnClick={(row) => sendEmailOnClick(row)}
            sendEmailLable="Send Mail to Contacts"
            reportHistory={checkPrivileges([12])}
            reportHistoryLable="Report History"
            reportHistoryOnClick={(row) => reportHistoryOnClick(row)}
            viewProject={true}
            viewProjectLabel={"View Project"}
            viewProjectOnClick={(row) => viewProjectOnClick(row)}
          />
        ) : statusId === 7 &&
          rows?.row?.isFluid &&
          isTodayOrUpcoming &&
          !isProfile ? (
          <ReportRowManipulte
            rows={rows}
            addBtn={checkPrivileges([12, 102, 103, 104])}
            addBtnLabel={"Add Report"}
            addForm={() => handleAddOnClick(rows?.row)}
          />
        ) : null;
      },
    },
  ];

  const openItemCountColumn = columns.find(
    (column) => column.field === "openItemCount",
  );
  const inspectionByColumn = columns.find(
    (column) => column.field === "inspectionBy",
  );
  // Show the Open Items column on the Missed (5) and Completed (6) tabs only.
  if (statusId === 5 || statusId === 6) {
    openItemCountColumn.hide = false;
    // inspectionByColumn.hide = true;
  }
  if (statusId === 7) {
    openItemCountColumn.hide = true;
  }
  if ((statusId === 5 || statusId === 6) && isProfile) {
    openItemCountColumn.hide = true;
    inspectionByColumn.hide = false;
  }

  const baseColumnVisibility = retrievedColumnVisibility
    ? retrievedColumnVisibility
    : columnVisibilityModel;

  const swReportColumnVisibilityModel = {
    ...baseColumnVisibility,
    openItemCount: !openItemCountColumn.hide,
  };

  const columnsDownloads = [
    {
      field: "requestId",
      headerName: "Request ID",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
    },
    {
      field: "time",
      headerName: "Time",
      flex: 1,
    },
    {
      field: "clientName",
      headerName: "Client",
      flex: 1,
    },
    {
      field: "requestedByName",
      headerName: "Requested By ",
      flex: 1,
    },
    {
      field: "fileUrl",
      headerName: "Link",
      flex: 1.2,
      renderCell: (rows) => (
        <Grid className="catListBox">
          <Grid className="closeIcon">
            {/* {rows?.row?.fileUrl?.slice(0, 24)}...{" "} */}
            Download file{" "}
            {rows?.row?.status === "Active" && (
              <a
                rel="noopener noreferrer"
                href={rows?.row?.fileUrl}
                target="_blank"
              >
                <img src={commonImages.download} alt="" />
              </a>
            )}
          </Grid>
        </Grid>
      ),
    },
    {
      field: "",
      headerName: "",
      flex: 0.01,
      renderCell: (rows) => (
        <Grid container className="catListBox">
          {/* <Grid container justifyContent={"left"} className="closeIcon">
            
          </Grid> */}
        </Grid>
      ),
    },
  ];

  useEffect(() => {
    if (isFirstStatusRender.current) {
      isFirstStatusRender.current = false;
    } else if (statusId) {
      setFromDate(null);
      setToDate(null);
    }
    if (stateData && !isFromDashboard) {
      setProjects({
        key: stateData?.projectId ?? "",
        value: stateData?.projectName ?? "",
      });

      setClients({
        key: stateData?.customerId ?? "",
        value: stateData?.customerName ?? "",
      });
      const data = {
        page: 1,
        search: search ? search : "",
        projectId: stateData?.projectId ? stateData?.projectId : 0,
        customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
        statusId: statusId,
        inspectionTypeId: inspectionType ? inspectionType : 0,
        frequencyId: frequencyId ? frequencyId : "",
        startDate: fromDate === null ? "" : getFormatedDate(fromDate),
        endDate:
          statusId === 7
            ? getFormatedDate(scalculatedDate)
            : toDate === null
              ? ""
              : toDate
                ? getFormatedDate(toDate)
                : "",
        pageSize: pageSize,
        userId:
          isProfile || isUseridPass || myReportsToggle
            ? parseInt(USER_ID())
            : "",
        projectObj: swInspectionListData?.filterObj?.projectObj,
        clientObj: swInspectionListData?.filterObj?.clientObj,
        statusIds: statusIdsvalue,
      };
      if (swInspectionListData?.filterObj?.projectObj) {
        setProjects(swInspectionListData?.filterObj?.projectObj);
      }
      if (swInspectionListData?.filterObj?.clientObj) {
        setClients(swInspectionListData?.filterObj?.clientObj);
      }
      getSwInspectionListData(data);
    }
  }, [statusId, stateData]);

  useEffect(() => {
    if (!stateData) {
      setAsssetName(true);
      setClientName(true);
    }
  }, [stateData]);
  useEffect(() => {
    if (statusId === 7 && stodayDate) {
      setFromDate(stodayDate);
      setToDate(scalculatedDate);
    }
  }, [statusId, stodayDate]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (hasRestoredFromSession.current) {
      hasRestoredFromSession.current = false;
      return;
    }
    setPage(0);
    const data = {
      search: debouncedSearch,
      inspectionTypeId: inspectionType ? inspectionType : 0,
      frequencyId: frequencyId ? frequencyId : "",
      projectId: projects?.key ? projects?.key : 0,
      customerId: clients?.key ? clients?.key : parseInt(ORG_ID()),
      statusId,
      startDate: fromDate === null ? "" : getFormatedDate(fromDate),
      endDate:
        statusId === 7
          ? getFormatedDate(scalculatedDate)
          : toDate === null
            ? ""
            : toDate
              ? getFormatedDate(toDate)
              : "",
      page: 1,
      pageSize: pageSize,
      userId:
        isProfile || isUseridPass || myReportsToggle ? parseInt(USER_ID()) : "",
      projectObj: swInspectionListData?.filterObj?.projectObj,
      clientObj: swInspectionListData?.filterObj?.clientObj,
      isDailyReport: false,
      statusIds: statusIdsvalue,
      stateId: selectedStateId,
    };

    getSwInspectionListData(data);
  }, [debouncedSearch]);

  return (
    <>
      {swOpenItemDetail.isLoading && <Loader />}
      <section className="grid_main_sec">
        {openModal && (
          <DialogBox
            open={openModal}
            rows={[]}
            header={"Confirm Deletion"}
            deletehandle={deletehandle}
            handleCloseModal={() => setOpenModal(false)}
            content={contentMessage}
            view
          />
        )}
        {!isProfile && (
          <div className="grid_main_header two_grid">
            <Grid container item md={12} xs={12} className="">
              <Grid container className="confBox">
                <Grid item md={8} xs={12}>
                  <div className="confTitile">
                    {HBView || adminView
                      ? "Inspection Record"
                      : "My Inspection Record"}
                  </div>
                </Grid>

                <Grid item md={8} xs={12}>
                  <div className="btnStatusWrapper">
                    {CHECK_PRE && (
                      <div
                        className={
                          statusId === 5
                            ? "btnStatusIns active"
                            : "btnStatusIns"
                        }
                        onClick={() => {
                          setSearch("");
                          setPage(0);
                          setDownloadsPage(0);
                          setPageSize(PAGE_SIZE);
                          setPageSizeDownloads(PAGE_SIZE);
                          setProjects();
                          setClients();
                          setInspectionType("");
                          setFrequencyId("");
                          setFromDate(null);
                          setToDate(null);
                          statusHander(5);
                          setSelectedStateId("");
                        }}
                      >
                        Missed
                      </div>
                    )}
                    <div
                      className={
                        statusId === 6 ? "btnStatusIns active" : "btnStatusIns"
                      }
                      onClick={() => {
                        setSearch("");
                        setPage(0);
                        setDownloadsPage(0);
                        setPageSize(PAGE_SIZE);
                        setPageSizeDownloads(PAGE_SIZE);
                        setProjects();
                        setClients();
                        setInspectionType("");
                        setFrequencyId("");
                        setFromDate(null);
                        setToDate(null);
                        statusHander(6);
                        setSelectedStateId("");
                      }}
                    >
                      Completed
                    </div>

                    {CHECK_PRE && (
                      <div
                        className={
                          statusId === 7
                            ? "btnStatusIns active"
                            : "btnStatusIns"
                        }
                        onClick={() => {
                          setSearch("");
                          setPage(0);
                          setDownloadsPage(0);
                          setPageSize(PAGE_SIZE);
                          setPageSizeDownloads(PAGE_SIZE);
                          setProjects();
                          setClients();
                          setInspectionType("");
                          setFrequencyId("");
                          setFromDate(null);
                          setToDate(null);
                          statusHander(7);
                          setSelectedStateId("");
                        }}
                      >
                        Scheduled
                      </div>
                    )}
                    {CHECK_PRE && (
                      <div
                        className={
                          statusId === 8
                            ? "btnStatusIns active"
                            : "btnStatusIns"
                        }
                        onClick={() => {
                          setSearch("");
                          setPage(0);
                          setDownloadsPage(0);
                          setPageSize(PAGE_SIZE);
                          setPageSizeDownloads(PAGE_SIZE);
                          setProjects();
                          setClients();
                          setInspectionType("");
                          setFrequencyId("");
                          setFromDate(null);
                          setToDate(null);
                          statusHander(8);
                          setSelectedStateId("");
                        }}
                      >
                        Downloads
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}

        {statusId !== 8 && (
          <Grid container mb={2}>
            <Grid lg={8} md={12} xs={12} pr={2} item>
              <Grid container spacing={2}>
                {HBView && !isProfile && (
                  <Grid lg={6} xs={12} sm={12} md={6} item>
                    <FormControl fullWidth>
                      <FormLabels label="Client" isRequired={false} />
                      <SearchAutoComplete
                        name="Add Individual Users"
                        optionsData={allClients ?? []}
                        typeOnchange={(event, value) => {
                          searchClient(event, value);
                        }}
                        isKeyValuePair={true}
                        value={clients}
                        onChange={(e, value) => onChangeClients(value)}
                        isLoading={isSearchClientLoading}
                        autoCompClear={autoComp}
                        noOptionsTextMsg={"No Client"}
                      />
                    </FormControl>
                  </Grid>
                )}

                {(HBView || adminView || CHECK_PRE_SHOW) && !isProfile && (
                  <Grid lg={6} xs={12} sm={12} md={6} item>
                    <FormControl fullWidth>
                      <FormLabels label="Project" isRequired={false} />
                      <SearchAutoComplete
                        name="Add Individual Users"
                        optionsData={allProject?.data ?? []}
                        typeOnchange={(event, value) =>
                          handleAllProjectSearch(event, value)
                        }
                        isKeyValuePair={true}
                        value={projects}
                        onChange={(e, value) => onChangeProjects(value)}
                        isLoading={isProjectLoading}
                        autoCompClear={autoCompPro}
                        noOptionsTextMsg={"No Project"}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
        <div className="grid_main_body">
          {statusId !== 8 && (
            <Grid container alignItems="center">
              <Grid item lg={9} md={12} xs={12}>
                <div className="filter_of_caselist filter_btn_wrapper">
                  <div className="searchcaseid filter_btn_caseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  <div className="filter_btn swreport_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>

                    <FilterCommonStatusSelect
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      statusType={INSSTATUS}
                      handleApply={handleApply}
                      handleClear={handleClear}
                      filter={filter}
                      onChangeType={onChangeType}
                      statusIds={statusIds}
                      selectLable={"Inspection Type"}
                      categoryType={inspectionTypeValue?.insTypeMstList}
                      category={inspectionType}
                      categoryOnChanges={inspectionTypeOnChanges}
                      filterSelect={true}
                      filterStatus={false}
                      resetBtn={true}
                      filterDate={true}
                      toDate={toDate}
                      fromDate={fromDate}
                      onchangeToDatePicker={onchangeToDatePicker}
                      onchangeFromDatePicker={onchangeFromDatePicker}
                      scalculatedDate={scalculatedDate}
                      statusId={statusId}
                      frequencySelect={true}
                      frequencyLable={"Frequency"}
                      frequencyType={inspectionTypeValue?.insfrequencyList}
                      frequencyId={frequencyId}
                      frequencyOnChanges={frequencyOnChanges}
                      statusFilterSelect={true}
                      statusSelectLable={"State"}
                      statusCategoryType={state}
                      statusCategory={selectedStateId}
                      statusCategoryOnChanges={stateOnChanges}
                    />

                    {!isProfile && (
                      <div className="myReportToggle">
                        <span>My Inspection Reports</span>
                        <Tooltip title="Show only inspections assigned to me">
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <ISwitch
                          checked={myReportsToggle}
                          onChange={handleMyReportsToggle}
                          name="status"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
              <Grid item lg={3}>
                {selectedReports.length > 0 && (
                  <div>
                    <Buttons
                      onClick={() => {
                        if (InactiveClient()) return;
                        if (selectedReports?.length > SW_REPORTS_COUNT)
                          setselectedREportsError(true);
                        else
                          getBulkInspectionDetailsData(
                            selectedReports,
                            clients?.key,
                          );
                      }}
                      varientContained={true}
                      label={"Send Report"}
                    />
                  </div>
                )}
                <Grid justifyContent={"center"} item container>
                  {selectedREportsError && (
                    <div className="errorMsg">
                      Please select up to {SW_REPORTS_COUNT} records
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}
          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {statusId === 8 ? (
                <GridTable
                  getRowId={(r) => r.requestId}
                  rows={
                    getBulkInspectionFiles?.isLoading
                      ? []
                      : (getBulkInspectionFiles?.data?.result ?? [])
                  }
                  rowCount={getBulkInspectionFiles?.data?.itemsCount ?? 0}
                  columns={columnsDownloads}
                  checkboxSelection={false}
                  loading={getBulkInspectionFiles?.isLoading}
                  page={downloadsPage}
                  pagination
                  pageSize={pageSizeDownloads}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeDownloadsChange}
                  onPageChange={handleDownloadsPagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick={true}
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              ) : (
                <GridTable
                  key={columnVisibilityKey}
                  getRowId={(r) => r.reportId}
                  rows={swInspectionList ?? []}
                  rowCount={count ?? 0}
                  columns={columns}
                  checkboxSelection={
                    (statusId === 6 && clients?.key && !isProfile) ||
                    (clientView && statusId === 6 && !isProfile) ||
                    (!HBView && statusId === 6 && !isProfile)
                  }
                  loading={isLoading}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick={true}
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  onSelectionModelChange={(e) => {
                    setselectedREportsError(false);
                    setSelectedReports(e);
                  }}
                  isRowSelectable={(rows) =>
                    selectedReports.length < SW_REPORTS_COUNT ||
                    selectedReports.indexOf(rows.row.reportId) >= 0
                  }
                  disableColumnMenu={false}
                  disableColumnSelector={false}
                  disableColumnFilter={false}
                  initialState={{
                    columns: {
                      columnVisibilityModel: swReportColumnVisibilityModel,
                    },
                  }}
                  onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel1(newModel, columnVisibilityKey)
                  }
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReportList;
